/*
Suresh Peddavoora 10/30/2022 2698403495  Added client maintenance title in header  */
import React, {useState} from 'react';
import CustomTabs from './Pages';
import LandingPage from '../LandingPage';
import General from './Pages/General';

export default function DetailedView() {
  const [tabs, setTabs] = useState([
    {label: 'Pending Transactions (W33)', deleteIcon: true},
    {label: 'Imaging (W47)', deleteIcon: true},
    {label: 'Letter History (W52)', deleteIcon: true},
    {label: 'Health Insurance Info (W703)', deleteIcon: true},
    {label: 'Collectors Script (W705)', deleteIcon: true},
    {label: 'Skip Tools (W557)', deleteIcon: true},
    {label: 'Special Notes', deleteIcon: true},
    {label: 'Payments', deleteIcon: true},
    {label: 'Notes', deleteIcon: true},
    {label: 'Account Multiples', deleteIcon: true},
    {label: 'Tie Parameters (W51)', deleteIcon: true},
  ]);
  const [selected, setSelected] = useState([]);

  return (
    <LandingPage tabs={tabs} title={'Client Maintenance'} showTabs={true} setTabs={setTabs} selected={selected} setSelected={setSelected}>
      <div className="fixed-header">
        <div className="dashboard-content-collapse client-maintenance-content">
          <div id="third">
            <General />
          </div>
          <CustomTabs selected={selected} setSelected={setSelected} />
        </div>
      </div>
    </LandingPage>
  );
}
